import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=3bff3ac1"
import script from "./ListTable.vue?vue&type=script&lang=js"
export * from "./ListTable.vue?vue&type=script&lang=js"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=3bff3ac1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports